function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.013 0v64h10.74V0h-10.74zm27.234 0v64h10.74V0h-10.74z",
  fill: "currentColor"
});

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIyIj4KICA8cGF0aCBkPSJNMTMuMDEzIDB2NjRoMTAuNzRWMGgtMTAuNzR6TTQwLjI0NyAwdjY0aDEwLjc0VjBoLTEwLjc0eiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { SvgPause as ReactComponent };